import React from 'react'
import BreadCrumbsComponent from '../common/BreadCrumbs'

export default function TermsCrumbs() {
  return (
    <BreadCrumbsComponent firstLevel={"Home"} secondLevel={"Legal"} mainHeading={"Terms and Conditions"}/>
  )
}
